import type { Schema } from '@cli-types/core-engine/schema.js'
import { RESERVED_AUTHORSHIP_FIELD_NAMES } from '@cli-constants/schema.js'
import { flattenFields } from '@core-engine/schema/field-helpers/flattening/flatten-fields.js'

export function collectReservedAuthorshipFieldErrors(
  schema: Schema,
  schemaKind: 'entity' | 'single',
  errors: string[]
): void {
  for (const field of flattenFields(schema.fields || [])) {
    if (RESERVED_AUTHORSHIP_FIELD_NAMES.has(field.name)) {
      errors.push(
        `${schemaKind} schema "${schema.name}" declares reserved field "${field.name}". BetterStart generates "${field.name}" as authorship metadata or companion data.`
      )
    }
  }
}
